
import React, { useState } from "react";
import { PerformanceInsights } from "./types";
import PerformanceTrajectoriesTab from "./tabs/PerformanceTrajectoriesTab";
import TalentSegmentationTab from "./tabs/TalentSegmentationTab";
import SkillsAnalysisTab from "./tabs/SkillsAnalysisTab";
import LeadershipPipelineTab from "./tabs/LeadershipPipelineTab";
import PerformanceAnalyticsTab from "./tabs/PerformanceAnalyticsTab";
import PredictiveIntelligenceTab from "./tabs/PredictiveIntelligenceTab";

interface AnalysisTabsProps {
  insights: PerformanceInsights;
}

const AnalysisTabs = ({ insights }: AnalysisTabsProps) => {
  const [activeView, setActiveView] = useState<"summary" | "talent-development" | "skills" | "leadership-pipeline" | "performance-analytics" | "predictive-intelligence">("summary");

  return (
    <div className="mt-1 space-y-3">
      {/* Sub-tab Navigation */}
      <div className="border-b border-primary/20">
        <div className="flex my-0 py-[6px] px-0 mx-px overflow-x-auto">
          <button 
            onClick={() => setActiveView("summary")} 
            className={`px-4 py-3 text-sm font-medium transition-colors whitespace-nowrap ${
              activeView === "summary" 
                ? "text-primary border-b-2 border-primary bg-primary/10" 
                : "text-gray-400 hover:text-white"
            }`}
          >
            Summary
          </button>

          <button 
            onClick={() => setActiveView("leadership-pipeline")} 
            className={`px-4 py-3 text-sm font-medium transition-colors whitespace-nowrap ${
              activeView === "leadership-pipeline" 
                ? "text-primary border-b-2 border-primary bg-primary/10" 
                : "text-gray-400 hover:text-white"
            }`}
          >
            Succession Planning
          </button>


          <button 
            onClick={() => setActiveView("skills")} 
            className={`px-4 py-3 text-sm font-medium transition-colors whitespace-nowrap ${
              activeView === "skills" 
                ? "text-primary border-b-2 border-primary bg-primary/10" 
                : "text-gray-400 hover:text-white"
            }`}
          >
            Skills Gap
          </button>



          <button 
            onClick={() => setActiveView("performance-analytics")} 
            className={`px-4 py-3 text-sm font-medium transition-colors whitespace-nowrap ${
              activeView === "performance-analytics" 
                ? "text-primary border-b-2 border-primary bg-primary/10" 
                : "text-gray-400 hover:text-white"
            }`}
          >
            Performance Calibration
          </button>

          <button 
            onClick={() => setActiveView("predictive-intelligence")} 
            className={`px-4 py-3 text-sm font-medium transition-colors whitespace-nowrap ${
              activeView === "predictive-intelligence" 
                ? "text-primary border-b-2 border-primary bg-primary/10" 
                : "text-gray-400 hover:text-white"
            }`}
          >
            Predictive Analytics
          </button>

          
        </div>
      </div>

      {/* Summary View */}
      {activeView === "summary" && (
        <div>
          <h3 className="text-[24px] font-medium text-white mb-3">Performance Summary</h3>
          <PerformanceTrajectoriesTab insights={insights} />
        </div>
      )}

      {/* Talent Development View */}
      {activeView === "talent-development" && (
        <div>
          <h3 className="text-[24px] font-medium text-white mb-3">Talent Development</h3>
          <TalentSegmentationTab insights={insights} />
        </div>
      )}

      {/* Leadership Pipeline Intelligence View */}
      {activeView === "leadership-pipeline" && (
        <div>
          <h3 className="text-[24px] font-medium text-white mb-3">Succession Planning Analysis</h3>
          <LeadershipPipelineTab insights={insights} />
        </div>
      )}

      {/* Performance Calibration Analytics View */}
      {activeView === "performance-analytics" && (
        <div>
          <h3 className="text-[24px] font-medium text-white mb-3">Performance Calibration Analysis</h3>
          <PerformanceAnalyticsTab insights={insights} />
        </div>
      )}

      {/* Predictive Talent Analytics View */}
      {activeView === "predictive-intelligence" && (
        <div>
          <h3 className="text-[24px] font-medium text-white mb-3">Predictive Talent Analytics</h3>
          <PredictiveIntelligenceTab insights={insights} />
        </div>
      )}

      {/* Skills View */}
      {activeView === "skills" && (
        <div>
          <h3 className="text-[24px] font-medium text-white mb-3">Skills Gap Analysis</h3>
          <SkillsAnalysisTab insights={insights} />
        </div>
      )}
    </div>
  );
};

export default AnalysisTabs;
